import { AuditLogType } from "@/interfaces";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useGetLeadAuditLogs = (leadId: number, enabled: boolean = true) => {
  return useQuery({
    queryKey: ["audit-logs", "leads", leadId],
    queryFn: async (): Promise<{
      data: AuditLogType[];
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    }> => {
      const response = await axios.get(`/api/audit-logs/leads/${leadId}`);
      return response.data;
    },
    enabled: enabled && !!leadId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useGetEntityAuditLogs = (
  entityType: "lead" | "itinerary" | "booking" | "payment",
  entityId: string,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ["audit-logs", entityType, entityId],
    queryFn: async (): Promise<{
      data: AuditLogType[];
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    }> => {
      const response = await axios.get(`/api/audit-logs/${entityType}/${entityId}`);
      return response.data;
    },
    enabled: enabled && !!entityId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
